import { useRef, useEffect } from "react";

/**
 * Custom hook for getting previous value after side effect runs
 * @param {*} value
 * @return {oject}
 */
const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export default usePrevious;
